import type { GeometryPadWidgetConfig } from '../geometrypad.model';

/**
 * Triangle with both annotation types:
 * - LengthAnnotation on edge AB (dimension line with offset)
 * - ArrowAnnotation pointing to vertex C with a label
 */
export const ANNOTATIONS_PRESET: GeometryPadWidgetConfig = {
  id: 'annotations',
  type: 'geometrypad',
  params: {
    elements: {
      t1: {
        type: 'Triangle',
        params: { a: 5, b: 7, gamma: 50 },
      },
      lenAB: {
        type: 'LengthAnnotation',
        params: { of: 't1.edge.AB', offset: 1.5 },
      },
      arrowC: {
        type: 'ArrowAnnotation',
        params: { target: 't1.point.C', label: 'Vertex C', offset: [2, 2], routing: 'straight' },
      },
      arrowEdge: {
        type: 'ArrowAnnotation',
        params: { target: 't1.edge.AB', label: 'Side c', offset: [0, -3], routing: 'straight' },
      },
    },
  },
  display: {
    geometry: {
      label: { coloring: true },
    },
  },
};
